import React, { useState } from 'react';
import {
  Button,
  Box,
} from '@mui/material';
// import { TextArea } from 'src/components/elements';
import EditorInline from 'src/components/elements/Editor/Inline';
import {
  MdAddCircleOutline,
  MdEdit,
} from 'react-icons/md';
import moment from 'moment';
import { confirmWrapper } from 'src/components/Dialog';
import {
  CloseActiveIcon,
  CloseSquareIcon,
  ConfirmActiveIcon,
  ConfirmSquareIcon,
} from 'src/icons';

interface EditComment {
  id: number | null;
  notes: string;
}

const EditNote = function (props: any) {
  const {
    value: noteValue,
    onChange,
    onCancel,
    onSubmit,
  } = props;

  const [isCloseHovered, setIsCloseHovered] = useState(false);
  const [isConfirmHovered, setIsConfirmHovered] = useState(false);

  const handleMouseEnterClose = () => {
    setIsCloseHovered(true);
  };

  const handleMouseLeaveClose = () => {
    setIsCloseHovered(false);
  };

  const handleMouseEnterConfirm = () => {
    setIsConfirmHovered(true);
  };

  const handleMouseLeaveConfirm = () => {
    setIsConfirmHovered(false);
  };

  return (
    <Box className="relative bg-white">
      {/* <TextArea
        value={noteValue}
        onChange={onChange}
        rows={10}
      /> */}
      <EditorInline
        value={noteValue}
        onChange={onChange}
      />
      <Box className="z-[1] absolute flex gap-[2px] right-1 bottom-0">
        <Box
          className="cursor-pointer"
          onMouseEnter={handleMouseEnterClose}
          onMouseLeave={handleMouseLeaveClose}
          onClick={onCancel}
        >
          {isCloseHovered ? (
            <CloseActiveIcon size={20} />
          ) : (
            <CloseSquareIcon size={20} />
          )}
        </Box>
        <Box
          className="cursor-pointer"
          onMouseEnter={handleMouseEnterConfirm}
          onMouseLeave={handleMouseLeaveConfirm}
          onClick={onSubmit}
        >
          {isConfirmHovered ? (
            <ConfirmActiveIcon size={20} />
          ) : (
            <ConfirmSquareIcon size={20} />
          )}
        </Box>
      </Box>
    </Box>
  );
};

const Notes = function (props: any) {
  const {
    jobOrderId,
    value = [],
    addJobNote,
    updateJobNote,
  } = props;

  const [addNote, setAddNote] = useState(false);
  const [noteValue, setNoteValue] = useState('');
  const [editNote, setEditNote] = useState<EditComment>({
    id: null,
    notes: '',
  });

  const onEdit = (id: number, notes: string) => {
    setEditNote({
      id,
      notes,
    });
  };

  const onEditChange = (e: string) => {
    setEditNote((prevState) => ({ ...prevState, notes: e }));
  };

  const onChange = (e: string) => {
    setNoteValue(e);
  };

  const onCancel = () => {
    setAddNote(false);
    setNoteValue('');
    setEditNote({ id: null, notes: '' });
  };

  const onAddNote = async () => {
    const request = {
      jobOrderId,
      notes: noteValue,
    };
    const confirmation = await confirmWrapper(
      'Are you sure you want to add note?',
      {
        variant: 'warning',
        primaryBtnLabel: 'Proceed',
        secondaryBtnLabel: 'Cancel',
      },
    );

    if (confirmation) {
      try {
        await addJobNote(request);
        setAddNote(false);
        setNoteValue('');
        setEditNote({ id: null, notes: '' });
      } catch (e) {
        console.log(e);
      }
    }
  };

  const onEditNote = async () => {
    const { id, notes } = editNote;
    const request = {
      jobOrderId,
      notes,
    };

    const confirmation = await confirmWrapper(
      'Are you sure you want to edit note?',
      {
        variant: 'warning',
        primaryBtnLabel: 'Proceed',
        secondaryBtnLabel: 'Cancel',
      },
    );

    if (confirmation) {
      try {
        await updateJobNote(request, id);
        setAddNote(false);
        setNoteValue('');
        setEditNote({ id: null, notes: '' });
      } catch (e) {
        console.log(e);
      }
    }
  };

  return (
    <Box className="w-full h-full">
      {
        value.map((comment: any) => (
          <Box className="relative" key={comment?.id}>
            {comment.id === editNote.id ? (
              <EditNote
                value={editNote?.notes}
                onChange={onEditChange}
                onCancel={onCancel}
                onSubmit={onEditNote}
              />
            ) : (
              <Box className="bg-white p-5 my-1 rounded group">
                <Box className="flex gap-2">
                  <Box className="grow-0 shrink-0 basis-1/4">
                    <Box className="font-bold text-md leading-5 pb-2">{comment?.recruiter}</Box>
                    <Box className="text-xs leading-5 text-[#828A97]">
                      {moment(comment.updatedDate).format('MM/DD/YYYY hh:mm A')}
                    </Box>
                  </Box>
                  <Box className="grow-0 shrink-0 basis-3/4">
                    <Box>
                      <EditorInline
                        value={comment.notes}
                        disabled
                      />
                    </Box>
                  </Box>
                </Box>

                <Box className="z-[1] absolute right-5 top-3">
                  <Box
                    className="cursor-pointer pb-1 group-hover:visible invisible"
                    onClick={() => onEdit(comment.id, comment.notes)}
                  >
                    <MdEdit size="14" color="#828A97" />
                  </Box>
                </Box>
              </Box>
            )}
          </Box>
        ))
      }
      <Box>
        {addNote ? (
          <EditNote
            value={noteValue}
            onChange={onChange}
            onCancel={onCancel}
            onSubmit={onAddNote}
          />
        ) : (
          <Button
            variant="text"
            className="rounded-lg"
            onClick={() => setAddNote(true)}
            startIcon={<MdAddCircleOutline />}
          >
            Add Note
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default Notes;
